'use client';

import { useConfig } from '@/app/contexts/ConfigContext';
import CustomLink from './CustomLink';
import { SERVICE_TYPES } from '@/helpers/enums';
import { ServiceType } from '@/types';

export default function NavMultiFitnessYogaPilates() {
  const { config, setConfig, wording, updateWording, selectedLanguage } =
    useConfig();

  const handleConfig = (type: ServiceType) => {
    setConfig({
      ...config,
      serviceType: type,
    });
    updateWording(type, selectedLanguage);
  };

  const styleLink =
    'text-neutral-800 p-5 text-xl flex justify-center font-bold';

  return (
    <div className='hidden 2xl:flex items-center gap-2 sm:gap-4 2xl:gap-8'>
      <div className='group'>
        <div className='text-neutral-800 text-xl font-bold flex justify-center flex-row items-center cursor-pointer p-5'>
          <span style={{ color: config.theme.textColorDark }}>
            {wording?.components_header_media_content}
          </span>
          <div>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g id='Chevron right'>
                <path
                  id='Vector'
                  d='M18 9.99984L16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984Z'
                  fill={config.theme.textColorDark || '#000'}
                />
              </g>
            </svg>
          </div>
        </div>
        <div
          className='z-20 absolute hidden bg-white shadow group-hover:block'
          style={{ backgroundColor: config.theme.backgroundColor }}
        >
          <CustomLink
            href='/media/media_1'
            onClick={() => {
              handleConfig(SERVICE_TYPES.FITNESS);
            }}
          >
            <div
              className='text-neutral-800 text-xl font-bold flex justify-center flex-row items-center cursor-pointer p-5'
              style={{ color: config.theme.textColorDark }}
            >
              {wording?.components_header_media_1}
            </div>
          </CustomLink>
          <CustomLink
            href='/media/media_2'
            onClick={() => {
              handleConfig(SERVICE_TYPES.FITNESS);
            }}
          >
            <div
              className='text-neutral-800 text-xl font-bold flex justify-center flex-row items-center cursor-pointer p-5'
              style={{ color: config.theme.textColorDark }}
            >
              {wording?.components_header_media_2}
            </div>
          </CustomLink>
        </div>
      </div>
      <CustomLink
        href='/media/media_all'
        onClick={() => {
          handleConfig(SERVICE_TYPES.YOGA);
        }}
      >
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_media_multi_content_2}
        </div>
      </CustomLink>
      <CustomLink
        href='/media/media_all'
        onClick={() => {
          handleConfig(SERVICE_TYPES.PILATES);
        }}
      >
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_media_multi_content_3}
        </div>
      </CustomLink>
      <CustomLink href='/text1'>
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_text1}
        </div>
      </CustomLink>
      <CustomLink href='/text2'>
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_text2}
        </div>
      </CustomLink>
    </div>
  );
}
